





import { computed, defineComponent } from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import PurchaseDashboard from '@/components/Dashboard/PurchaseDashboard.vue';
import StoreDashboard from '@/components/Dashboard/StoreDashboard.vue';
import ProductionDashboard from '@/components/Dashboard/ProductionDashboard.vue';

const DynamicDashboard = defineComponent({
  components: {
    PurchaseDashboard,
    StoreDashboard,
    ProductionDashboard,
  },
  setup(props, { root }) {
    const { route } = useRouter();

    const computedComponent = computed(() => {
      if (route.value.meta.component === 'PurchaseDashboard' && root.$store.getters.dashboard.indexOf('purchase') > -1) return PurchaseDashboard;
      if (route.value.meta.component === 'ProductionDashboard' && root.$store.getters.dashboard.indexOf('prod') > -1) return ProductionDashboard;
      if (route.value.meta.component === 'StoreDashboard' && root.$store.getters.dashboard.indexOf('store') > -1) return StoreDashboard;
      return null;
    });

    return {
      computedComponent,
    };
  },
});

export default DynamicDashboard;
